<template>
  <v-flex class="section-1 general-bg" ma-0 pt-4 px-4>
    <!-- DIALOG AGENCIES -->
    <v-dialog
      v-model="showAgencies"
      max-width="500px"
      persistent
    >
      <v-card>
        <v-flex class="text-xs-center" px-2 pt-3 pb-2>
          <h2>Seleccionar Agencia</h2>
        </v-flex>
        <agencies-tree :from-section="fromSection" />
        <v-flex d-flex pa-3 mx-2>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            @click="cancelAngeciesTree"
          >
            Cancelar
        </v-btn>
          <v-btn
            color="primary"
            :disabled="agencySelected === null"
            @click="showAgencies = false"
          >
            Aceptar
          </v-btn>
        </v-flex>
      </v-card>
    </v-dialog>
    <h3 class="text-xs-left pt-2">Alertas estacionarias (minuta de servicio)</h3>
    <h4 class="text-xs-left pt-2">Reporte por Tiempo</h4>
    <!-- SELECT AGENCY -->
    <v-flex my-2 py-3>
      <v-flex class="caption" pl-2>*Opcional</v-flex>
      <h5 class="pl-2">Seleccionar Agencia</h5>
      <v-btn
        color="primary"
        block
        :loading="$loading.isLoading('fetchingAgenciesTree')"
        @click="showAgencies = true"
      >
        <v-icon left>business</v-icon>
        Agencias
      </v-btn>
      <!-- AGENCY SELECTED -->
      <v-flex v-if="agencySelected && !$loading.isLoading('fetchingAgenciesTree')" pl-2>
        <h6>Agenica Seleccionada</h6>
        <h5>{{ agencySelected.name }}</h5>
      </v-flex>
    </v-flex>
    <!-- DATE & TIME -->
    <v-flex px-1 mt-3 pb-3>
      <!-- DATE INTERVAL FOR DATE1 & DATE2 -->
      <v-flex>
        <v-menu
          v-model="menu0"
          ref="menu0"
          lazy
          transition="scale-transition"
          offset-x
          left
          full-width
          origin="top left"
          nudge-right="300"
          nudge-top="-40"
          color="white"
          :close-on-content-click="false"
          :return-value.sync="dates0"
        >
          <template v-slot:activator="{ on }">
            <v-combobox
              v-model="dates0"
              label="Fecha"
              placeholder="Escoger el día a consultar"
              multiple
              chips
              small-chips
              prepend-inner-icon="event"
              readonly
              box
              color="white"
              v-on="on"
            >
            </v-combobox>
          </template>
          <v-date-picker 
            v-model="dates0"
            multiple
            no-title
            scrollable
            locale="es-sp"
            color="blue accent-3"
            :first-day-of-week="1"
            :allowed-dates="allowedDates0"
            @input="changesDate0"
          >
            <v-spacer></v-spacer>
            <v-btn color="error" @click="menu0 = false">Cancelar</v-btn>
            <v-btn color="primary" @click="acceptDate0">Aceptar</v-btn>
          </v-date-picker>
        </v-menu>
      </v-flex>
      <!-- MENU TIME 1 DATE 1 -->
      <v-flex v-if="showInitialTime0">
        <v-menu
          v-model="time1Date1Menu0"
          ref="time1Date1Menu0"
          lazy
          transition="scale-transition"
          offset-x
          left
          full-width
          allow-overflow
          min-width="290px"
          origin="top left"
          nudge-right="750"
          nudge-bottom="0"
          :close-on-content-click="false"
          :return-value.sync="time1Date10"
        >
          <v-text-field
            v-model="time1Date10"
            label="Hora Inicial"
            placeholder="Seleccionar Hora"
            slot="activator"
            prepend-inner-icon="av_timer"
            readonly
            box
            hide-details
            color="white"
          />
          <v-time-picker
            v-model="time1Date10"
            landscape
            format="24hr"
            scrollable
            color="teal darken-1"
            header-color="grey darken-4"
            :allowed-hours="allowedHours0"
            :allowed-minutes="allowedMinutes0"
            @input="changeTime10"
          >
            <v-spacer></v-spacer>
            <v-btn color="error" @click="time1Date1Menu0 = false">Cancelar</v-btn>
            <v-btn color="primary" @click="acceptTime10">Aceptar</v-btn>
          </v-time-picker>
        </v-menu>
      </v-flex>
      <!-- TIME 2 DATE 1 MENU -->
      <v-flex v-if="showFinalTime0" mt-3>
        <v-menu
          v-model="time2Date1Menu0"
          ref="time2Date1Menu0"
          lazy
          transition="scale-transition"
          offset-x
          left
          full-width
          min-width="290px"
          origin="top left"
          nudge-right="750"
          nudge-bottom="0"
          :close-on-content-click="false"
          :return-value.sync="time2Date10"
        >
          <v-text-field
            v-model="time2Date10"
            slot="activator"
            label="Hora Final"
            placeholder="Seleccionar Hora"
            prepend-inner-icon="av_timer"
            readonly
            box
            hide-details
            color="white"
          />
          <v-time-picker
            v-model="time2Date10"
            landscape
            format="24hr"
            scrollable
            color="red darken-1"
            header-color="grey darken-4"
            :allowed-hours="allowedHours1"
            :allowed-minutes="allowedMinutes1"
            @input="inputTime20"
          >
            <v-spacer></v-spacer>
            <v-btn color="error" @click="time2Date1Menu0 = false">Cancelar</v-btn>
            <v-btn color="primary" @click="$refs.time2Date1Menu0.save(time2Date10)">Aceptar</v-btn>
          </v-time-picker>
        </v-menu>
      </v-flex>
      <!-- MIN VALUES -->
      <v-flex v-if="showFinalTime0" pt-3>
        <v-flex>
          <v-subheader class="pt-0 pl-0">Duración mínima de la estacionaria (minutos)</v-subheader>
          <v-slider
            v-model="minOutTime"
            :max="240"
            :min="15"
            always-dirty
            persistent-hint
            thumb-label="always"
            thumb-size="24"
            prepend-inner-icon="av_timer"
          ></v-slider>
        </v-flex>
      </v-flex>
    </v-flex>
    <!-- MESSAGE -->
    <p v-if="!reportButtonDisabled">
      <v-icon>warning</v-icon>
      La información contenida en los reportes por Alertas Estacionarias (minuta de servicio) , corresponde a las alertas mostradas en el panel de control en tiempo real, según las condiciones de funcionamiento de la minuta de servicio.
    </p>
    <!-- BUTTON -->
    <v-flex class="text-xs-center" mt-4 pb-2>
      <v-btn
        v-if="!reportReadyPAT"
        target="_blank"
        color="primary"
        block
        :disabled="reportButtonDisabled"
        :loading="$loading.isLoading('generatingReportParkingAlarmsTime')"
        @click="getReport"
      >
        <v-icon left>description</v-icon>
        Generar Reporte
      </v-btn>
      <v-btn
        v-if="reportReadyPAT"
        target="_blank"
        color="success"
        block
        :href="urlReportPAT"
        @click="downloadReport(toggleBtnPAT(false))"
      >
        <v-icon left>cloud_download</v-icon>
        Descargar Reporte
      </v-btn>
    </v-flex>
    <!-- CLEAR FORM -->
    <v-flex
      v-if="showClearForm"
      class="text-xs-center"
      pb-3
    >
      <v-btn
        color="red"
        block
        @click="clearFormIn"
      >
        <v-icon left>clear</v-icon>
        Limpiar Datos
      </v-btn>
    </v-flex>
  </v-flex>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { reportsMixin1 } from '../../mixins/reportsMixin1.js'
import AgenciesTree from '../AgenciesTree'

export default {
  name: 'report-parking-alarms-time',
  mixins: [reportsMixin1],
  components: {
    AgenciesTree
  },
  data() {
    return {
      fromSection: 'reports-parking-alarms',
      amountOfHours: 9,
      minOutTime: 15
    }
  },
  computed: {
    ...mapGetters(['agencySelected', 'reportReadyPAT', 'urlReportPAT'])
  },
  methods: {
    ...mapActions(['getReportParkingAlarmsTime', 'toggleBtnPAT']),
    getReport() {
      const payload = {
        startDate: `${this.date10} ${this.time1Date10}`,
        endDate: `${this.date20} ${this.time2Date10}`,
        minDuration: this.minOutTime
      }
      if (this.agencySelected) payload.agencyId = this.agencySelected.agencyId
      this.getReportParkingAlarmsTime(payload)
    },
    clearFormIn() {
      this.minOutTime = 15
      this.clearForm()
    }
  },
  created() {
    this.fromDateAllowed = '2021-06-23'
  }
}
</script>

<style lang="stylus" scoped>
h3
  font-size 30px
  font-weight 500
  line-height 28px

h4
  font-size 21px
  font-weight 500

.section-1
  min-width 390px
  max-width 390px
  
.general-bg
  background-color #424242
  border-radius 3px
</style>


// WEBPACK FOOTER //
// src/components/Reports/ReportParkingAlarmsTime.vue